import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_14.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/modern');
  const shareText = encodeURIComponent('Launches HR Voices!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title> Modern Workplaces — Outstanding Workplaces</title>
        <meta property="og:title" content=" Modern Workplaces — Outstanding Workplaces" />
        <meta property="og:description" content="The Heart of Modern Workplaces HR Voices by Outstanding Workplaces" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778046561/i_14_mhx3cd.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/modern" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Modern Workplaces — Outstanding Workplaces" />
        <meta name="twitter:description" content="The Heart of Modern Workplaces HR Voices by Outstanding Workplaces" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778046561/i_14_mhx3cd.jpg" />
      </Helmet>

       <div className="sight_14_page_wrapper">
        <div className="sight_14_content_container">

          <div className="sight_14_section_one">

            {/* TITLE */}
            <h1 className="sight_14_page_title">
              The Heart of Modern Workplaces HR Voices by Outstanding Workplaces
            </h1>

            {/* ROW */}
            <div className="sight_14_row">

              {/* LEFT */}
              <div className="sight_14_left">
                <div className="sight_14_image_wrapper">
                  <img src="/assets/i_14.jpg" alt="Team meeting discussion" className="sight_14_blog_image" />
                </div>

                {/* SHARE SECTION */}
                <div className="sight_14_share_section">
                  <span className="sight_14_share_text">Share :</span>
                  <div className="sight_14_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_14_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_14_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_14_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_14_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

             
              <p className="sight_14_intro_paragraph p1">
                  In today’s fast-evolving world of work, organizations are realizing that employee engagement and wellbeing are no longer optional - they are business essentials. As companies navigate change, uncertainty, and rising expectations, the focus has shifted from managing performance to nurturing people.
                </p>
                
                <p className="sight_14_intro_paragraph p2">
                  At HR Voices by Outstanding Workplaces, this conversation takes center stage.
                </p>

              </div>

              {/* RIGHT */}
              <div className="sight_14_right">
                <div className="sight_14_ad_card">
                  <img src="/assets/bc_1.png" className="sight_14_ad_bg" />
                  <div className="sight_14_ad_overlay"></div>
                  <img src="/assets/bg_1.png" className="sight_14_ad_badge" />

                  <div className="sight_14_ad_content">
                    <h2>
                      Earn the Outstanding <br />
                      <span>Workplaces Certification</span>
                    </h2>

                    <ul>
                      <li>Attract Top Talent</li>
                      <li>Boost Employee Engagement</li>
                      <li>Drive Culture-Led Growth</li>
                    </ul>

                    <button
                      className="sight_14_ad_btn"
                      onClick={() => window.location.href = '/nominate'}
                    >
                      Get Certificate
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>


          {/* ===== SECTION TWO ===== */}
          <div className="sight_14_section">

            <div className="sight_14_topics">

              <div className="sight_14_topic_item">
                <h2 className="sight_14_topic_heading">
                  The New Definition of Engagement
                </h2>

                <p className="sight_14_intro">
                  Employee engagement today goes beyond satisfaction surveys and annual feedback. It is about creating meaningful experiences where employees feel:
                </p>

                <ul className="sight_14_topic_list">
                  <li>Valued and heard</li>
                  <li>Connected to purpose</li>
                  <li>Motivated to contribute</li>
                  <li>Supported in their growth</li>
                </ul>

                <p className="sight_14_description">
                  Engaged employees don’t just work — they care, innovate, and lead.
                </p>
              </div>




              <div className="sight_14_topic_item">
                <h2 className="sight_14_topic_heading">
                  Why Wellbeing Matters More Than Ever
                </h2>

                <p className="sight_14_intro">
                  Wellbeing is no longer limited to physical health. Modern workplaces must address a holistic view that includes:
                </p>

                <ul className="sight_14_topic_list">
                  <li>Mental and emotional health</li>
                  <li>Work-life balance</li>
                  <li>Financial stability</li>
                  <li>Social connection and belonging</li>
                </ul>

                <p className="sight_14_description">
                  Organizations that invest in wellbeing see higher productivity, lower attrition, and stronger workplace culture.
                </p>
              </div>




              <div className="sight_14_topic_item">
                <h2 className="sight_14_topic_heading">
                  HR Voices: Driving the Conversation
                </h2>

                <p className="sight_14_intro">
                  HR Voices brings together HR leaders and industry experts to explore how organizations can create people-first workplaces. Through powerful discussions and shared insights, the platform highlights:
                </p>

                <ul className="sight_14_topic_list">
                  <li>Innovative employee engagement strategies</li>
                  <li>Real-world wellbeing initiatives</li>
                  <li>Leadership approaches that build trust and empathy</li>
                  <li>Culture-building practices that sustain long-term success</li>
                </ul>

                <p className="sight_14_description">
                  These conversations go beyond theory — they focus on practical, actionable ideas that organizations can implement.
                </p>
              </div>



              <div className="sight_14_topic_item">
                <h2 className="sight_14_topic_heading">
                  Bridging Engagement and Performance
                </h2>

                <p className="sight_14_intro">
                  There is a direct link between engaged, healthy employees and organizational success. Companies that prioritize people experience:
                </p>

                <ul className="sight_14_topic_list">
                  <li>Increased innovation and collaboration</li>
                  <li>Stronger employer branding</li>
                  <li>Improved retention and talent attraction</li>
                  <li>Sustainable business growth</li>
                </ul>

                <p className="sight_14_description">
                  Simply put, when people thrive, businesses thrive.
                </p>
              </div>



              <div className="sight_14_topic_item">
                <h2 className="sight_14_topic_heading">
                  Creating a Culture of Care
                </h2>

                <p className="sight_14_intro">
                  Building a culture of engagement and wellbeing requires intentional effort. It starts with:
                </p>

                <ul className="sight_14_topic_list">
                  <li>Listening actively to employees</li>
                  <li>Empowering managers to lead with empathy</li>
                  <li>Providing flexibility and trust</li>
                  <li>Recognizing contributions meaningfully</li>
                </ul>

                <p className="sight_14_description">
                  It’s not about one-time initiatives — it’s about embedding care into everyday work.
                </p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default BlogPage;
